export default {
  label: {
    saveTooltip: 'Save',
    cancelTooltip: 'Cancel',
  },
};
